import TextColumnContent from './TextColumnContent';

export default TextColumnContent;
